// extracted by mini-css-extract-plugin
export default {"message-image":"style_message-image__v-kIt"};